/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Booked_ByInputs */

const en_admin_dashboard_booked_by = /** @type {(inputs: Admin_Dashboard_Booked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`booked by`)
};

const de_admin_dashboard_booked_by = /** @type {(inputs: Admin_Dashboard_Booked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gebucht von`)
};

const es_admin_dashboard_booked_by = /** @type {(inputs: Admin_Dashboard_Booked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reservado por`)
};

const fr_admin_dashboard_booked_by = /** @type {(inputs: Admin_Dashboard_Booked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`réservé par`)
};

const nl_admin_dashboard_booked_by = /** @type {(inputs: Admin_Dashboard_Booked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gereserveerd door`)
};

const it_admin_dashboard_booked_by = /** @type {(inputs: Admin_Dashboard_Booked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prenotato da`)
};

const pt_br2_admin_dashboard_booked_by = /** @type {(inputs: Admin_Dashboard_Booked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reservado por`)
};

const pl_admin_dashboard_booked_by = /** @type {(inputs: Admin_Dashboard_Booked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwowano przez`)
};

const hu_admin_dashboard_booked_by = /** @type {(inputs: Admin_Dashboard_Booked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lefoglalta:`)
};

const ro_admin_dashboard_booked_by = /** @type {(inputs: Admin_Dashboard_Booked_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rezervat de`)
};

/**
* | output |
* | --- |
* | "booked by" |
*
* @param {Admin_Dashboard_Booked_ByInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_booked_by = /** @type {((inputs?: Admin_Dashboard_Booked_ByInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Booked_ByInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_booked_by(inputs)
	if (locale === "de") return de_admin_dashboard_booked_by(inputs)
	if (locale === "es") return es_admin_dashboard_booked_by(inputs)
	if (locale === "fr") return fr_admin_dashboard_booked_by(inputs)
	if (locale === "nl") return nl_admin_dashboard_booked_by(inputs)
	if (locale === "it") return it_admin_dashboard_booked_by(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_booked_by(inputs)
	if (locale === "pl") return pl_admin_dashboard_booked_by(inputs)
	if (locale === "hu") return hu_admin_dashboard_booked_by(inputs)
	return ro_admin_dashboard_booked_by(inputs)
});
export { admin_dashboard_booked_by as "admin.dashboard.booked_by" }